(() => {
  function init(root = document) {
    root.querySelectorAll('.ig-buy-form').forEach(form => {
      if (form.dataset.igReady) return;
      form.dataset.igReady = 'true';
      const selector = form.querySelector('[data-ig-variant]');
      const update = () => {
        const option = selector.selectedOptions[0];
        form.querySelector('[data-ig-price]').textContent = option.dataset.price;
        const button = form.querySelector('[data-ig-add]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
      };
      selector.addEventListener('change', update);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
